import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  class: "pop_up com_pop",
  style: {"display":"block","max-height":"100%"}
}
const _hoisted_2 = { class: "pop_tit _flex" }
const _hoisted_3 = { class: "sign_form" }
const _hoisted_4 = { class: "custom_scroll" }
const _hoisted_5 = { class: "select_date_wrap" }
const _hoisted_6 = { class: "select_date" }
const _hoisted_7 = { class: "select_date" }
const _hoisted_8 = { style: {"display":"flex","align-items":"center"} }
const _hoisted_9 = { class: "select_date_wrap" }
const _hoisted_10 = { class: "select_date" }
const _hoisted_11 = { class: "li_con" }
const _hoisted_12 = { class: "li_con" }
const _hoisted_13 = { class: "file_wrap" }
const _hoisted_14 = { for: "area_file" }
const _hoisted_15 = { class: "file_list" }
const _hoisted_16 = { class: "file_name" }
const _hoisted_17 = ["onClick"]
const _hoisted_18 = { class: "file_name" }
const _hoisted_19 = ["onClick"]
const _hoisted_20 = { class: "_flex _center btn_wrap" }
const _hoisted_21 = ["textContent"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ModalDefault = _resolveComponent("ModalDefault")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: "pop_up_layer com_pop",
      style: {"display":"block"},
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.closeModal && $setup.closeModal(...args)))
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("p", null, "캠페인·이벤트 " + _toDisplayString($setup.state.idx === 0 ? "등록" : "수정"), 1),
        _createElementVNode("button", {
          class: "close_btn icon_wrap",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => ($setup.closeModal && $setup.closeModal(...args)))
        }, [...(_cache[14] || (_cache[14] = [
          _createElementVNode("img", {
            src: "img/close.png",
            alt: "닫기"
          }, null, -1)
        ]))])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("ul", _hoisted_4, [
          _createElementVNode("li", {
            class: _normalizeClass({ imp: $setup.state.mode })
          }, [
            _cache[15] || (_cache[15] = _createElementVNode("label", {
              for: "title",
              class: "form_li_tit"
            }, "제목", -1)),
            _withDirectives(_createElementVNode("input", {
              id: "title",
              type: "text",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.state.data.title) = $event))
            }, null, 512), [
              [_vModelText, $setup.state.data.title]
            ])
          ], 2),
          _createElementVNode("li", {
            class: _normalizeClass({ imp: $setup.state.mode })
          }, [
            _cache[16] || (_cache[16] = _createElementVNode("label", {
              for: "duration",
              class: "form_li_tit"
            }, "모집기간", -1)),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _withDirectives(_createElementVNode("input", {
                  type: "date",
                  name: "",
                  id: "",
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.form_state.recruitStartDate) = $event))
                }, null, 512), [
                  [_vModelText, $setup.form_state.recruitStartDate]
                ])
              ]),
              _createElementVNode("div", _hoisted_7, [
                _withDirectives(_createElementVNode("input", {
                  type: "date",
                  name: "",
                  id: "",
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.form_state.recruitEndDate) = $event))
                }, null, 512), [
                  [_vModelText, $setup.form_state.recruitEndDate]
                ])
              ])
            ])
          ], 2),
          _createElementVNode("li", {
            class: _normalizeClass({ imp: $setup.state.mode })
          }, [
            _cache[18] || (_cache[18] = _createElementVNode("label", {
              for: "title",
              class: "form_li_tit"
            }, "모집인원", -1)),
            _createElementVNode("div", _hoisted_8, [
              _withDirectives(_createElementVNode("input", {
                id: "title",
                type: "text",
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($setup.state.data.cntApply) = $event))
              }, null, 512), [
                [_vModelText, $setup.state.data.cntApply]
              ]),
              _cache[17] || (_cache[17] = _createElementVNode("span", { style: {"font-weight":"500","color":"#000","font-size":"100%","display":"inline-block"} }, "명", -1))
            ])
          ], 2),
          _createElementVNode("li", {
            class: _normalizeClass({ imp: $setup.state.mode })
          }, [
            _cache[19] || (_cache[19] = _createElementVNode("label", {
              for: "duration",
              class: "form_li_tit"
            }, "신청 종료일", -1)),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _withDirectives(_createElementVNode("input", {
                  type: "date",
                  name: "",
                  id: "",
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($setup.form_state.applyDate) = $event))
                }, null, 512), [
                  [_vModelText, $setup.form_state.applyDate]
                ])
              ])
            ])
          ], 2),
          _createElementVNode("li", {
            class: _normalizeClass(["li_con", { imp: $setup.state.mode }])
          }, [
            _cache[20] || (_cache[20] = _createElementVNode("label", {
              for: "editor1",
              class: "form_li_tit",
              "aria-placeholder": "내용을 입력해주세요."
            }, "내용", -1)),
            _withDirectives(_createElementVNode("textarea", {
              id: "editor1",
              name: "editor1",
              class: "custom_scroll",
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (($setup.state.data.content) = $event))
            }, null, 512), [
              [_vModelText, $setup.state.data.content]
            ])
          ], 2),
          _createElementVNode("li", {
            class: _normalizeClass(["li_con", { imp: $setup.state.mode }])
          }, [
            _cache[21] || (_cache[21] = _createElementVNode("label", {
              for: "editor2",
              class: "form_li_tit",
              "aria-placeholder": "개인정보 동의 문구를 입력해주세요."
            }, [
              _createTextVNode(" 개인정보 수집 "),
              _createElementVNode("br"),
              _createTextVNode(" 및 이용 동의 ")
            ], -1)),
            _withDirectives(_createElementVNode("textarea", {
              id: "editor2",
              name: "editor2",
              class: "custom_scroll",
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (($setup.state.data.term) = $event))
            }, null, 512), [
              [_vModelText, $setup.state.data.term]
            ])
          ], 2),
          _createElementVNode("li", _hoisted_11, [
            _cache[22] || (_cache[22] = _createElementVNode("label", {
              for: "editor1",
              class: "form_li_tit",
              "aria-placeholder": "이벤트 URL을 입력해주세요."
            }, "이벤트 URL", -1)),
            _withDirectives(_createElementVNode("input", {
              id: "pop_url",
              type: "text",
              placeholder: "이벤트 URL을 입력해주세요.",
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (($setup.form_state.urlForEvent) = $event))
            }, null, 512), [
              [_vModelText, $setup.form_state.urlForEvent]
            ])
          ]),
          _createElementVNode("li", _hoisted_12, [
            _cache[23] || (_cache[23] = _createElementVNode("label", {
              for: "editor1",
              class: "form_li_tit",
              "aria-placeholder": "콜백 URL을 입력해주세요."
            }, "콜백 URL", -1)),
            _withDirectives(_createElementVNode("input", {
              id: "callback_url",
              type: "text",
              placeholder: "콜백 URL을 입력해주세요.",
              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (($setup.form_state.urlCallback) = $event))
            }, null, 512), [
              [_vModelText, $setup.form_state.urlCallback]
            ])
          ]),
          _createElementVNode("li", _hoisted_13, [
            _cache[29] || (_cache[29] = _createElementVNode("span", { class: "form_li_tit" }, "첨부", -1)),
            _createElementVNode("label", _hoisted_14, [
              _createElementVNode("input", {
                id: "area_file",
                type: "file",
                placeholder: "",
                accept: "image/*",
                multiple: "",
                onChange: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => ($setup.handleFiles && $setup.handleFiles(...args)))
              }, null, 32),
              _cache[24] || (_cache[24] = _createElementVNode("div", { class: "file_box_wrap" }, "‘파일첨부’ 버튼을 클릭하거나 파일을 드래그하여 첨부해주세요", -1)),
              _cache[25] || (_cache[25] = _createElementVNode("span", {
                class: "blue_btn",
                style: {"display":"flex","justify-content":"center","align-items":"center"}
              }, "파일첨부", -1)),
              _cache[26] || (_cache[26] = _createElementVNode("p", { class: "p_info" }, "200M 이하 JPG, PNG 파일을 첨부해주세요.", -1))
            ]),
            _createElementVNode("div", _hoisted_15, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.state.data.fileList, (item, idx) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "file",
                  key: idx
                }, [
                  _createElementVNode("span", _hoisted_16, _toDisplayString(item.imgRealName), 1),
                  _createElementVNode("button", {
                    class: "file_del icon_wrap",
                    onClick: ($event: any) => ($setup.fileRemove(item.idx))
                  }, [...(_cache[27] || (_cache[27] = [
                    _createElementVNode("img", {
                      src: "img/close_02.png",
                      alt: ""
                    }, null, -1)
                  ]))], 8, _hoisted_17)
                ]))
              }), 128)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.state.file, (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "file",
                  key: index
                }, [
                  _createElementVNode("span", _hoisted_18, _toDisplayString(item.name), 1),
                  _createElementVNode("button", {
                    class: "file_del icon_wrap",
                    onClick: ($event: any) => ($setup.removeFile(index))
                  }, [...(_cache[28] || (_cache[28] = [
                    _createElementVNode("img", {
                      src: "img/close_02.png",
                      alt: ""
                    }, null, -1)
                  ]))], 8, _hoisted_19)
                ]))
              }), 128))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_20, [
          _createElementVNode("button", {
            class: "submit_btn _130 _main_blue",
            onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => ($setup.save && $setup.save(...args))),
            textContent: _toDisplayString($setup.state.mode ? '등록' : '수정')
          }, null, 8, _hoisted_21)
        ])
      ])
    ]),
    ($setup.state.isShowModal)
      ? (_openBlock(), _createBlock(_component_ModalDefault, {
          key: 0,
          type: $setup.state.modalTab,
          title: $setup.state.modalTitle,
          content: $setup.state.modalContent,
          onClose: _cache[13] || (_cache[13] = ($event: any) => ($setup.state.isShowModal = false)),
          onCallback: $setup.callBackModal
        }, null, 8, ["type", "title", "content", "onCallback"]))
      : _createCommentVNode("", true)
  ], 64))
}